var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0536 14.3706C9.66311 14.7611 9.02999 14.7611 8.63948 14.3706L6.29537 12.0267C5.8347 11.5661 5.08787 11.5661 4.6272 12.0267C4.16648 12.4874 4.16648 13.2343 4.6272 13.695L8.63948 17.7069C9.02999 18.0974 9.66311 18.0974 10.0536 17.7069L19.9652 7.79627C20.4259 7.33559 20.4259 6.58863 19.9652 6.12795C19.5045 5.66733 18.7577 5.66733 18.297 6.12795L10.0536 14.3706Z",
    fill: "#00A931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckedGreen);
export default __webpack_public_path__ + "static/media/ic_checked_green.c94e464d58bb6bd8f8e18a9b4d353ee7.svg";
export { ForwardRef as ReactComponent };